import { React } from '_core';

const MetricBasketReturnsByAsset = () => <></>;
export default MetricBasketReturnsByAsset;
